module.exports = __webpack_public_path__ + "cac74af0d2eb00f812d2f1539b3e3ac9.svg";